import React, {useState } from "react";
import Dropdown from "./Dropdown";

import { Formik } from "formik";

const Basic = () => {
  // use for ids
  let i = 0;

  // fake data to build dropdown list
  // you can set the pre selected value use selected tag.
  let dp = [
    { value: 1, label: "option 1", selected: false },
    { value: 2, label: "option 2", selected: false },
    { value: 3, label: "option 3", selected: false },
    { value: 4, label: "option 4", selected: false }
  ];
  // store dropdown selected value
  const [dpvalue4, setDpvalue4] = useState();

  return (
    <div>

      <hr />
      <Formik
        initialValues={{
          dropdown1: ""
        }}
        // all validation rules go in here
        validate={(values) => {
          const errors = {};


          // dropdown, need select one
          if (values.dropdown1 === "DEFAULT" || values.dropdown1.length === 0) {

            errors.dropdown1 = "Please select one.";
          }

    
          // return errors object with all error strings
          return errors;
        }}
        onSubmit={(values, { setSubmitting }) => {
          setTimeout(() => {
            // ajax submit functions goes here
            // now just do an alert
            alert(JSON.stringify(values, null, 2));
            setSubmitting(false);
          }, 1);
        }}
        validateOnBlur={true}
        validateOnChange={false}
      >
        {({
          values /* all data need to run the valdation*/,
          errors /* all error strings */,
          touched /* all field touch event  */,
          handleChange /* value change event handler */,
          handleBlur /* onBlur event handler */,
          handleSubmit /* for submit button */
          /* and other goodies */
        }) => (
          <form onSubmit={handleSubmit}>
            {/* email input box with error message */}
            <br />
            {/* password input with error message */}
            <br />
            <Dropdown
              data={dp}
              label="Drop down 4, not pre-selected"
              name="dropdown1"
              isRequired={true}
              helpMessage=""
              isDisabled={false}
              id={"dropdown_" + i++}
              // the old way to get selected value from dropdown component
              getSelectedValue={(dpvalue4) => setDpvalue4(dpvalue4)}
              // show error and error message is control by formik
              errorMessage={errors.dropdown1}
              hasError={touched.dropdown1 && errors.dropdown1}
              // return event to formik
              onChange={(e) => handleChange(e)}
              onBlur={(e) => handleBlur(e)}
              // onFocus event return TRUE, set touched to true, this can show/hide error message
              onFocus={(e) => {
                touched.dropdown1 = e;
              }}
              // allow user to select default option
              disableDefault={false}
              // user can change the text
              defaultLabel={"Select an Option"}
              // update formik value
             value={(dpvalue4) => {
                values.dropdown1 = dpvalue4; 
              }}
            />
            <br />
             -----------------------
            <br />
            formik values onChange and onBlur(focusOff)
            <br />
            showing item's value, touched, error
            <br />
            -----------------------
            <br />
           <br />
            dropdown1: {JSON.stringify(values.dropdown1)} - touched:
            {JSON.stringify(touched.dropdown1)} - error:{errors.dropdown1}.
            <br />
            -----------------------
          </form>
        )}
      </Formik>
      <span>react hook value</span>
      <span>dropdown selected : {dpvalue4}</span>
      <br />

      -----------------------
    </div>
  );
};

export default Basic;
